<template #default>
    <div class="content-wrapper">
        <div class="content-block dx-card responsive-paddings">
            <DxForm id="form1" :form-data="incorporationData">
                <DxGroupItem :caption="$t('forecasts.manageForecasts')" :col-count="1">
                    <DxSimpleItem name="ManageForecastsGrid_">
                        <template #default>
                            <DxDataGrid id="ManageForecastsGrid"
                                        :show-borders="true"
                                        :row-alternation-enabled="true"
                                        :hover-state-enabled="true"
                                        :data-source="ManageForecastsData"
                                        ref="dataGridRefKey"
                                        key-expr="Id">
                                <DxColumn
                                    data-field="No"
                                    :caption="$t('forecasts.no')"
                                    :allow-editing="false">
                                </DxColumn>

                                <DxColumn data-field="Year"
                                          :caption="$t('forecasts.year')">
                                </DxColumn>

                                <DxColumn data-field="Version"
                                          :caption="$t('forecasts.version')">
                                </DxColumn>

                                <DxColumn data-field="Quarter"
                                          :caption="$t('forecasts.quarter')">
                                </DxColumn>

                                <DxColumn data-field="Total_Forecast"
                                          :caption="$t('forecasts.totalForecast')">
                                </DxColumn>

                                <DxColumn data-field="Version"
                                          :caption="$t('forecasts.version')">
                                </DxColumn>

                                <DxMasterDetail
                                    :enabled="true"
                                    template="masterDetailTemplate"
                                />
                                <template #masterDetailTemplate="{ data: data }">
                                    <detail-template
                                    :template-data="data"
                                    />
                                </template>

                                <DxColumnFixing :enabled="true" />

                                <DxGroupPanel :visible="true" />

                                <DxExport :enabled="true"
                                          :formats="['pdf']"
                                          :allow-export-selected-data="true" />

                                <DxSearchPanel location="before"
                                               :visible="true"
                                               :highlight-case-sensitive="true" />
                                <DxPager :show-page-size-selector="true" />
                                <DxPaging :page-size="10" />
                            </DxDataGrid>
                        </template>
                    </DxSimpleItem>
                </DxGroupItem>
            </DxForm>
        </div>
    </div>
</template>

<script>
    import DxForm, {
        DxGroupItem,
        DxSimpleItem,
        DxButtonItem,
        DxLabel,
        DxRequiredRule,
        DxCompareRule,
        DxRangeRule,
        DxStringLengthRule,
        DxPatternRule,
        DxEmailRule,
        DxAsyncRule,
    } from 'devextreme-vue/form'
    import DxItemPanel from "devextreme-vue/tab-panel"
    import DxAutocomplete from 'devextreme-vue/autocomplete'
    import {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxToolbar,
        DxItem,
        DxFormItem,
        DxLookup,
        DxExport,
        DxSelection,
        DxGrouping,
        DxPager,
        DxPaging,
        DxSearchPanel,
        DxLoadPanel,
        DxMasterDetail,
        DxColumnFixing,
        DxGroupPanel,
    } from 'devextreme-vue/data-grid'

    import DxRadioGroup from 'devextreme-vue/radio-group'

    import DxButton from 'devextreme-vue/button'

    import notify from 'devextreme/ui/notify'

    import DetailTemplate from './template/forecast-detail-template.vue'

    import dateUtil from '@/helpers/dateUtil'

    import { jsPDF } from 'jspdf'
    import 'jspdf-autotable'
    import { exportDataGrid } from 'devextreme/pdf_exporter'
    import { Workbook } from 'exceljs'
    import { saveAs } from 'file-saver-es'

    import { mapState, mapActions } from 'vuex'

    import { GET_UIM_FORECAST } from '@/store/_actiontypes'

    const dataGridRefKey = "my-data-grid"

    export default {
        components: {
            DxGroupItem,
            DxSimpleItem,
            DxButtonItem,
            DxButton,
            DxRadioGroup,
            DxLabel,
            DxItemPanel,
            DxItem,
            DxDataGrid,
            DxColumn,
            DxEditing,
            DxFormItem,
            DxLookup,
            DxExport,
            DxSelection,
            DxPager,
            DxPaging,
            DxSearchPanel,
            DxMasterDetail,
            DxGrouping,
            DxLoadPanel,
            DxToolbar,
            DxItem,
            DxColumnFixing,
            DxGroupPanel,
            DxRequiredRule,
            DxCompareRule,
            DxPatternRule,
            DxRangeRule,
            DxEmailRule,
            DxStringLengthRule,
            DxForm,
            DxAutocomplete,
            DxAsyncRule,
            notify,
            DetailTemplate,
        },

        data() {
            const incorporationData = {}
            const status = [
                {
                    Id: true,
                    Name: 'Active'
                },
                {
                    Id: false,
                    Name: 'Inactive'
                }
            ]

            return {
                FacilityOptions: status,
                ProductOptions: status,
                dataOperation: ['New', 'Update'],
                selectedTabIndex: 0,
                isOrderVisible: true,
                dataGridRefKey,
                metaData: {},
                ManageForecastsData: [],
                PrintColor: { 'color': '#6caddf', 'text-decoration': 'underline' },
                buttonOptions: {
                    text: 'Save Changes',
                    type: 'default',
                },
                incorporationData
            }
        },

        computed: {
            dataGrid: function () {
                return this.$refs.dataGridRefKey.instance
            }
        },

        mounted() {
            this.loadData()
        },

        methods: {
            ...mapActions("application", [
                GET_UIM_FORECAST
            ]),

            loadData() {
                this.GET_UIM_FORECAST().then(res => {
                    this.bindData(res.data)      
                })
                .catch(error => {
                    console.log(error)
                })
            },

            bindData(data) {
                this.ManageForecastsData = data.map((item, index) => {
                    return {
                        No: index+1,
                        Id: item.id,
                        Year: item.year,
                        Quarter: item.quarter,
                        Quarter_Name: item.quarter_Name,
                        Total_Forecast: item.total_Forecast,
                        Comment: item.comment,
                        Version: item.version || 1,
                        Details: item.tbl_Uim_Forecast_Details
                    }
                })
            },
        }
    }
</script>